<script>
import AdminLayout from '@layouts/admin-main'
import BrokerageShareList from '@components/admin/brokerage-share-list'
import BrokerageNav from '@components/admin/brokerage-nav'

export default {
  page: {
    title: 'Admin::BrokerageCatalogShareList',
    meta: [
      { name: 'description', content: 'Admin::BrokerageCatalogShareList' },
    ],
  },
  components: { AdminLayout, BrokerageShareList, BrokerageNav },
}
</script>

<template>
  <AdminLayout>
    <BrokerageNav></BrokerageNav>
    <BrokerageShareList></BrokerageShareList>
  </AdminLayout>
</template>
